function Step () {

  const stepitem = document.querySelectorAll(".js-step-item")

  if(stepitem) {
    stepitem.forEach(element => {
      element.addEventListener("click",()=> {
        const currentStep = element.closest(".js-step")
        if(currentStep.classList.contains("is-show")) {
          currentStep.nextElementSibling.classList.add("is-show")
          currentStep.classList.remove("is-show")
        }
      })
      // const button = element.querySelector(".c-button-login")
      // const buttonToggle = element.closest(".js-step")
      // button ? button.disabled = true : null
    });
  }




  const lastToggle = document.querySelector(".js-step-item-end")
  const indicontainer = document.querySelector(".js-indicator-container")
  if(lastToggle) {
    lastToggle.addEventListener("click",()=> {
      indicontainer.style.display = 'none'
    })
  
  }


  
}

export {Step}